/**
 * @deprecated This static category list is deprecated and will be removed in a future version.
 * Use the `useCategoryHelpers` hook or `useProfessionalCategories` hook to fetch categories from the database.
 * Categories are now managed dynamically from the admin panel and stored in the `professional_categories` table.
 * 
 * This file is kept only as a fallback for edge cases where the database is unavailable.
 * 
 * @see src/hooks/useCategoryHelpers.ts
 * @see src/hooks/useProfessionalCategories.ts
 */
export const PROFESSIONAL_CATEGORIES = [
  // SALUTE MENTALE E BENESSERE
  {
    id: 'psychologist',
    icon: '🧠',
    it: { name: 'Psicologo/a', keywords: ['psicologia', 'terapia', 'salute mentale', 'supporto psicologico'] },
    en: { name: 'Psychologist', keywords: ['psychology', 'therapy', 'mental health', 'psychological support'] },
    es: { name: 'Psicólogo/a', keywords: ['psicología', 'terapia', 'salud mental', 'apoyo psicológico'] }
  },
  {
    id: 'psychotherapist',
    icon: '💭',
    it: { name: 'Psicoterapeuta', keywords: ['psicoterapia', 'terapia', 'analisi', 'percorso terapeutico'] },
    en: { name: 'Psychotherapist', keywords: ['psychotherapy', 'therapy', 'analysis', 'therapeutic journey'] },
    es: { name: 'Psicoterapeuta', keywords: ['psicoterapia', 'terapia', 'análisis', 'proceso terapéutico'] }
  },
  {
    id: 'psychiatrist',
    icon: '🏥',
    it: { name: 'Psichiatra', keywords: ['psichiatria', 'salute mentale', 'farmaci', 'diagnosi'] },
    en: { name: 'Psychiatrist', keywords: ['psychiatry', 'mental health', 'medication', 'diagnosis'] },
    es: { name: 'Psiquiatra', keywords: ['psiquiatría', 'salud mental', 'medicación', 'diagnóstico'] }
  },
  {
    id: 'therapist',
    icon: '💆',
    it: { name: 'Terapista', keywords: ['terapia', 'counseling', 'supporto', 'benessere'] },
    en: { name: 'Therapist', keywords: ['therapy', 'counseling', 'support', 'wellness'] },
    es: { name: 'Terapeuta', keywords: ['terapia', 'consejería', 'apoyo', 'bienestar'] }
  },
  {
    id: 'coach',
    icon: '🎯',
    it: { name: 'Coach', keywords: ['coaching', 'motivazione', 'sviluppo personale', 'obiettivi', 'life coach', 'business coach'] },
    en: { name: 'Coach', keywords: ['coaching', 'motivation', 'personal development', 'goals', 'life coach', 'business coach'] },
    es: { name: 'Coach', keywords: ['coaching', 'motivación', 'desarrollo personal', 'objetivos', 'life coach', 'business coach'] }
  },
  {
    id: 'mentor',
    icon: '🧭',
    it: { name: 'Mentore', keywords: ['mentoring', 'guida', 'formazione', 'esperienza', 'crescita professionale'] },
    en: { name: 'Mentor', keywords: ['mentoring', 'guidance', 'training', 'experience', 'professional growth'] },
    es: { name: 'Mentor', keywords: ['mentoría', 'guía', 'formación', 'experiencia', 'crecimiento profesional'] }
  },

  // SALUTE FISICA
  {
    id: 'general_doctor',
    icon: '⚕️',
    it: { name: 'Medico di base', keywords: ['medicina generale', 'dottore', 'medico famiglia'] },
    en: { name: 'General Practitioner', keywords: ['general medicine', 'doctor', 'GP', 'family doctor'] },
    es: { name: 'Médico de familia', keywords: ['medicina general', 'doctor', 'médico cabecera'] }
  },
  {
    id: 'specialist_doctor',
    icon: '👨‍⚕️',
    it: { name: 'Medico specialista', keywords: ['specialista', 'medicina', 'specializzazione'] },
    en: { name: 'Medical Specialist', keywords: ['specialist', 'medicine', 'specialization'] },
    es: { name: 'Médico especialista', keywords: ['especialista', 'medicina', 'especialización'] }
  },
  {
    id: 'dentist',
    icon: '🦷',
    it: { name: 'Dentista', keywords: ['odontoiatra', 'denti', 'ortodonzia', 'igiene orale'] },
    en: { name: 'Dentist', keywords: ['dental', 'teeth', 'orthodontics', 'oral hygiene'] },
    es: { name: 'Dentista', keywords: ['odontólogo', 'dientes', 'ortodoncia', 'higiene oral'] }
  },
  {
    id: 'nutritionist',
    icon: '🥗',
    it: { name: 'Nutrizionista', keywords: ['nutrizione', 'dieta', 'alimentazione', 'dietologo'] },
    en: { name: 'Nutritionist', keywords: ['nutrition', 'diet', 'food', 'dietitian'] },
    es: { name: 'Nutricionista', keywords: ['nutrición', 'dieta', 'alimentación', 'dietista'] }
  },
  {
    id: 'personal_trainer',
    icon: '💪',
    it: { name: 'Personal Trainer', keywords: ['fitness', 'allenamento', 'palestra', 'sport', 'preparatore atletico'] },
    en: { name: 'Personal Trainer', keywords: ['fitness', 'training', 'gym', 'sports', 'athletic trainer'] },
    es: { name: 'Entrenador Personal', keywords: ['fitness', 'entrenamiento', 'gimnasio', 'deporte', 'preparador físico'] }
  },
  {
    id: 'physiotherapist',
    icon: '🏃',
    it: { name: 'Fisioterapista', keywords: ['fisioterapia', 'riabilitazione', 'recupero', 'massoterapia'] },
    en: { name: 'Physiotherapist', keywords: ['physiotherapy', 'rehabilitation', 'recovery', 'physical therapy'] },
    es: { name: 'Fisioterapeuta', keywords: ['fisioterapia', 'rehabilitación', 'recuperación', 'terapia física'] }
  },
  {
    id: 'nurse',
    icon: '👩‍⚕️',
    it: { name: 'Infermiere/a', keywords: ['infermeria', 'assistenza', 'cure', 'sanitario'] },
    en: { name: 'Nurse', keywords: ['nursing', 'healthcare', 'care', 'medical'] },
    es: { name: 'Enfermero/a', keywords: ['enfermería', 'cuidados', 'asistencia', 'sanitario'] }
  },

  // LEGALE E AMMINISTRATIVO
  {
    id: 'lawyer',
    icon: '⚖️',
    it: { name: 'Avvocato/a', keywords: ['legale', 'diritto', 'legge', 'studio legale', 'avvocatura'] },
    en: { name: 'Lawyer', keywords: ['legal', 'law', 'attorney', 'law firm', 'barrister'] },
    es: { name: 'Abogado/a', keywords: ['legal', 'derecho', 'ley', 'despacho', 'abogacía'] }
  },
  {
    id: 'notary',
    icon: '📜',
    it: { name: 'Notaio', keywords: ['notarile', 'atti', 'rogiti', 'contratti'] },
    en: { name: 'Notary', keywords: ['notarial', 'deeds', 'contracts', 'public notary'] },
    es: { name: 'Notario', keywords: ['notarial', 'escrituras', 'contratos', 'fe pública'] }
  },
  {
    id: 'accountant',
    icon: '🧮',
    it: { name: 'Commercialista', keywords: ['contabilità', 'fisco', 'tasse', 'bilancio', 'partita iva'] },
    en: { name: 'Accountant', keywords: ['accounting', 'tax', 'finance', 'balance', 'bookkeeping'] },
    es: { name: 'Contador', keywords: ['contabilidad', 'impuestos', 'finanzas', 'balance', 'fiscal'] }
  },
  {
    id: 'financial_advisor',
    icon: '💰',
    it: { name: 'Consulente finanziario', keywords: ['finanza', 'investimenti', 'risparmio', 'pianificazione'] },
    en: { name: 'Financial Advisor', keywords: ['finance', 'investments', 'savings', 'planning'] },
    es: { name: 'Asesor financiero', keywords: ['finanzas', 'inversiones', 'ahorro', 'planificación'] }
  },

  // EVENTI E CELEBRAZIONI
  {
    id: 'wedding_planner',
    icon: '💒',
    it: { name: 'Wedding Planner', keywords: ['matrimonio', 'nozze', 'eventi', 'cerimonia', 'organizzazione matrimoni'] },
    en: { name: 'Wedding Planner', keywords: ['wedding', 'marriage', 'events', 'ceremony', 'bridal'] },
    es: { name: 'Organizador de bodas', keywords: ['boda', 'matrimonio', 'eventos', 'ceremonia', 'nupcial'] }
  },
  {
    id: 'photographer',
    icon: '📸',
    it: { name: 'Fotografo/a', keywords: ['fotografia', 'foto', 'ritratti', 'servizi fotografici', 'shooting'] },
    en: { name: 'Photographer', keywords: ['photography', 'photos', 'portraits', 'photoshoot', 'shooting'] },
    es: { name: 'Fotógrafo/a', keywords: ['fotografía', 'fotos', 'retratos', 'sesión fotográfica', 'shooting'] }
  },
  {
    id: 'videographer',
    icon: '🎥',
    it: { name: 'Videomaker', keywords: ['video', 'riprese', 'montaggio', 'filmati', 'videografia'] },
    en: { name: 'Videographer', keywords: ['video', 'filming', 'editing', 'footage', 'videography'] },
    es: { name: 'Videógrafo', keywords: ['video', 'filmación', 'edición', 'grabación', 'videografía'] }
  },
  {
    id: 'event_organizer',
    icon: '🎉',
    it: { name: 'Organizzatore eventi', keywords: ['eventi', 'feste', 'celebrazioni', 'meeting', 'congressi'] },
    en: { name: 'Event Organizer', keywords: ['events', 'parties', 'celebrations', 'meetings', 'conferences'] },
    es: { name: 'Organizador de eventos', keywords: ['eventos', 'fiestas', 'celebraciones', 'reuniones', 'congresos'] }
  },
  {
    id: 'dj',
    icon: '🎧',
    it: { name: 'DJ', keywords: ['musica', 'intrattenimento', 'festa', 'discoteca', 'animazione'] },
    en: { name: 'DJ', keywords: ['music', 'entertainment', 'party', 'disco', 'animation'] },
    es: { name: 'DJ', keywords: ['música', 'entretenimiento', 'fiesta', 'discoteca', 'animación'] }
  },
  {
    id: 'catering',
    icon: '🍽️',
    it: { name: 'Catering', keywords: ['cibo', 'ristorazione', 'banchetti', 'buffet', 'eventi'] },
    en: { name: 'Catering', keywords: ['food', 'restaurant', 'banquets', 'buffet', 'events'] },
    es: { name: 'Catering', keywords: ['comida', 'restauración', 'banquetes', 'buffet', 'eventos'] }
  },

  // BELLEZZA E CURA PERSONALE
  {
    id: 'hairdresser',
    icon: '💇',
    it: { name: 'Parrucchiere/a', keywords: ['capelli', 'taglio', 'acconciatura', 'colore', 'piega'] },
    en: { name: 'Hairdresser', keywords: ['hair', 'haircut', 'hairstyle', 'color', 'styling'] },
    es: { name: 'Peluquero/a', keywords: ['cabello', 'corte', 'peinado', 'color', 'estilismo'] }
  },
  {
    id: 'barber',
    icon: '💈',
    it: { name: 'Barbiere', keywords: ['barba', 'rasatura', 'baffi', 'grooming'] },
    en: { name: 'Barber', keywords: ['beard', 'shave', 'mustache', 'grooming'] },
    es: { name: 'Barbero', keywords: ['barba', 'afeitado', 'bigote', 'grooming'] }
  },
  {
    id: 'beautician',
    icon: '💅',
    it: { name: 'Estetista', keywords: ['estetica', 'bellezza', 'trattamenti', 'manicure', 'pedicure'] },
    en: { name: 'Beautician', keywords: ['beauty', 'aesthetics', 'treatments', 'manicure', 'pedicure'] },
    es: { name: 'Esteticista', keywords: ['estética', 'belleza', 'tratamientos', 'manicura', 'pedicura'] }
  },
  {
    id: 'makeup_artist',
    icon: '💄',
    it: { name: 'Makeup Artist', keywords: ['trucco', 'make-up', 'maquillage', 'truccatore'] },
    en: { name: 'Makeup Artist', keywords: ['makeup', 'cosmetics', 'maquillage', 'beauty'] },
    es: { name: 'Maquillador/a', keywords: ['maquillaje', 'cosméticos', 'belleza'] }
  },
  {
    id: 'massage_therapist',
    icon: '🧘',
    it: { name: 'Massaggiatore/trice', keywords: ['massaggi', 'relax', 'benessere', 'spa', 'shiatsu'] },
    en: { name: 'Massage Therapist', keywords: ['massage', 'relaxation', 'wellness', 'spa', 'shiatsu'] },
    es: { name: 'Masajista', keywords: ['masaje', 'relajación', 'bienestar', 'spa', 'shiatsu'] }
  },
  {
    id: 'tattoo_artist',
    icon: '🎨',
    it: { name: 'Tatuatore/trice', keywords: ['tatuaggi', 'tattoo', 'body art', 'piercing'] },
    en: { name: 'Tattoo Artist', keywords: ['tattoos', 'body art', 'piercing', 'ink'] },
    es: { name: 'Tatuador/a', keywords: ['tatuajes', 'arte corporal', 'piercing', 'tinta'] }
  },

  // EDUCAZIONE E FORMAZIONE
  {
    id: 'teacher',
    icon: '👨‍🏫',
    it: { name: 'Insegnante', keywords: ['scuola', 'educazione', 'docente', 'professore', 'maestro'] },
    en: { name: 'Teacher', keywords: ['school', 'education', 'educator', 'professor', 'instructor'] },
    es: { name: 'Profesor/a', keywords: ['escuela', 'educación', 'docente', 'maestro', 'instructor'] }
  },
  {
    id: 'private_tutor',
    icon: '📚',
    it: { name: 'Tutor privato', keywords: ['ripetizioni', 'lezioni private', 'doposcuola', 'aiuto compiti'] },
    en: { name: 'Private Tutor', keywords: ['tutoring', 'private lessons', 'homework help', 'study'] },
    es: { name: 'Tutor privado', keywords: ['tutoría', 'clases particulares', 'apoyo escolar', 'estudio'] }
  },
  {
    id: 'language_teacher',
    icon: '🗣️',
    it: { name: 'Insegnante di lingue', keywords: ['lingue', 'traduzioni', 'inglese', 'interpretariato'] },
    en: { name: 'Language Teacher', keywords: ['languages', 'translation', 'english', 'interpretation'] },
    es: { name: 'Profesor de idiomas', keywords: ['idiomas', 'traducción', 'inglés', 'interpretación'] }
  },

  // CASA E SERVIZI
  {
    id: 'real_estate_agent',
    icon: '🏠',
    it: { name: 'Agente immobiliare', keywords: ['immobili', 'casa', 'affitti', 'vendite', 'appartamenti'] },
    en: { name: 'Real Estate Agent', keywords: ['property', 'house', 'rentals', 'sales', 'apartments'] },
    es: { name: 'Agente inmobiliario', keywords: ['inmuebles', 'casa', 'alquileres', 'ventas', 'apartamentos'] }
  },
  {
    id: 'architect',
    icon: '📐',
    it: { name: 'Architetto', keywords: ['architettura', 'design', 'progetti', 'ristrutturazioni', 'costruzioni'] },
    en: { name: 'Architect', keywords: ['architecture', 'design', 'projects', 'renovations', 'construction'] },
    es: { name: 'Arquitecto', keywords: ['arquitectura', 'diseño', 'proyectos', 'reformas', 'construcción'] }
  },
  {
    id: 'interior_designer',
    icon: '🛋️',
    it: { name: 'Interior Designer', keywords: ['interni', 'arredamento', 'design', 'decorazione', 'home staging'] },
    en: { name: 'Interior Designer', keywords: ['interior', 'furniture', 'design', 'decoration', 'home staging'] },
    es: { name: 'Diseñador de interiores', keywords: ['interiores', 'mobiliario', 'diseño', 'decoración', 'home staging'] }
  },
  {
    id: 'cleaner',
    icon: '🧹',
    it: { name: 'Addetto/a pulizie', keywords: ['pulizie', 'domestico', 'colf', 'sanificazione'] },
    en: { name: 'Cleaner', keywords: ['cleaning', 'domestic', 'housekeeping', 'sanitization'] },
    es: { name: 'Personal de limpieza', keywords: ['limpieza', 'doméstico', 'hogar', 'sanitización'] }
  },
  {
    id: 'electrician',
    icon: '⚡',
    it: { name: 'Elettricista', keywords: ['elettrico', 'impianti', 'riparazioni', 'installazioni'] },
    en: { name: 'Electrician', keywords: ['electrical', 'systems', 'repairs', 'installations'] },
    es: { name: 'Electricista', keywords: ['eléctrico', 'sistemas', 'reparaciones', 'instalaciones'] }
  },
  {
    id: 'plumber',
    icon: '🔧',
    it: { name: 'Idraulico', keywords: ['idraulica', 'tubature', 'riparazioni', 'bagno', 'perdite'] },
    en: { name: 'Plumber', keywords: ['plumbing', 'pipes', 'repairs', 'bathroom', 'leaks'] },
    es: { name: 'Fontanero', keywords: ['fontanería', 'tuberías', 'reparaciones', 'baño', 'fugas'] }
  },

  // TURISMO E OSPITALITÀ
  {
    id: 'travel_agent',
    icon: '✈️',
    it: { name: 'Agente di viaggio', keywords: ['viaggi', 'turismo', 'vacanze', 'prenotazioni', 'tour operator'] },
    en: { name: 'Travel Agent', keywords: ['travel', 'tourism', 'holidays', 'bookings', 'tour operator'] },
    es: { name: 'Agente de viajes', keywords: ['viajes', 'turismo', 'vacaciones', 'reservas', 'tour operador'] }
  },
  {
    id: 'tour_guide',
    icon: '🗺️',
    it: { name: 'Guida turistica', keywords: ['tour', 'visite guidate', 'escursioni', 'musei'] },
    en: { name: 'Tour Guide', keywords: ['tours', 'guided visits', 'excursions', 'museums'] },
    es: { name: 'Guía turístico', keywords: ['tours', 'visitas guiadas', 'excursiones', 'museos'] }
  },
  {
    id: 'hotel',
    icon: '🏨',
    it: { name: 'Hotel/B&B', keywords: ['albergo', 'alloggio', 'pernottamento', 'bed and breakfast', 'ospitalità'] },
    en: { name: 'Hotel/B&B', keywords: ['accommodation', 'lodging', 'stay', 'bed and breakfast', 'hospitality'] },
    es: { name: 'Hotel/B&B', keywords: ['alojamiento', 'hospedaje', 'estancia', 'bed and breakfast', 'hospitalidad'] }
  },
  {
    id: 'restaurant',
    icon: '🍴',
    it: { name: 'Ristorante', keywords: ['ristorante', 'cibo', 'cucina', 'trattoria', 'pizzeria'] },
    en: { name: 'Restaurant', keywords: ['restaurant', 'food', 'cuisine', 'dining', 'pizzeria'] },
    es: { name: 'Restaurante', keywords: ['restaurante', 'comida', 'cocina', 'gastronomía', 'pizzería'] }
  },
  {
    id: 'bar',
    icon: '🍹',
    it: { name: 'Bar/Pub', keywords: ['bar', 'pub', 'locale', 'cocktail', 'aperitivo'] },
    en: { name: 'Bar/Pub', keywords: ['bar', 'pub', 'venue', 'cocktails', 'drinks'] },
    es: { name: 'Bar/Pub', keywords: ['bar', 'pub', 'local', 'cócteles', 'bebidas'] }
  },
  {
    id: 'cafe',
    icon: '☕',
    it: { name: 'Caffetteria', keywords: ['caffè', 'bar', 'colazione', 'pasticceria'] },
    en: { name: 'Café', keywords: ['coffee', 'café', 'breakfast', 'pastry'] },
    es: { name: 'Cafetería', keywords: ['café', 'cafetería', 'desayuno', 'pastelería'] }
  },

  // TECNOLOGIA E DIGITALE
  {
    id: 'web_developer',
    icon: '💻',
    it: { name: 'Sviluppatore Web', keywords: ['programmazione', 'siti web', 'coding', 'software', 'app'] },
    en: { name: 'Web Developer', keywords: ['programming', 'websites', 'coding', 'software', 'apps'] },
    es: { name: 'Desarrollador Web', keywords: ['programación', 'sitios web', 'código', 'software', 'apps'] }
  },
  {
    id: 'graphic_designer',
    icon: '🎨',
    it: { name: 'Graphic Designer', keywords: ['grafica', 'design', 'loghi', 'branding', 'illustrazioni'] },
    en: { name: 'Graphic Designer', keywords: ['graphics', 'design', 'logos', 'branding', 'illustrations'] },
    es: { name: 'Diseñador gráfico', keywords: ['gráficos', 'diseño', 'logos', 'branding', 'ilustraciones'] }
  },
  {
    id: 'social_media_manager',
    icon: '📱',
    it: { name: 'Social Media Manager', keywords: ['social', 'marketing', 'instagram', 'facebook', 'contenuti'] },
    en: { name: 'Social Media Manager', keywords: ['social', 'marketing', 'instagram', 'facebook', 'content'] },
    es: { name: 'Social Media Manager', keywords: ['redes sociales', 'marketing', 'instagram', 'facebook', 'contenido'] }
  },
  {
    id: 'it_consultant',
    icon: '🖥️',
    it: { name: 'Consulente IT', keywords: ['informatica', 'computer', 'assistenza', 'sistemista', 'reti'] },
    en: { name: 'IT Consultant', keywords: ['IT', 'computers', 'support', 'systems', 'networks'] },
    es: { name: 'Consultor IT', keywords: ['informática', 'computadoras', 'soporte', 'sistemas', 'redes'] }
  },
  {
    id: 'digital_marketer',
    icon: '📊',
    it: { name: 'Digital Marketing', keywords: ['marketing digitale', 'seo', 'sem', 'advertising', 'pubblicità'] },
    en: { name: 'Digital Marketer', keywords: ['digital marketing', 'seo', 'sem', 'advertising', 'ads'] },
    es: { name: 'Marketing Digital', keywords: ['marketing digital', 'seo', 'sem', 'publicidad', 'anuncios'] }
  },

  // ARTE E INTRATTENIMENTO
  {
    id: 'artist',
    icon: '🎨',
    it: { name: 'Artista', keywords: ['arte', 'quadri', 'pittura', 'scultura', 'galleria'] },
    en: { name: 'Artist', keywords: ['art', 'paintings', 'painting', 'sculpture', 'gallery'] },
    es: { name: 'Artista', keywords: ['arte', 'cuadros', 'pintura', 'escultura', 'galería'] }
  },
  {
    id: 'musician',
    icon: '🎵',
    it: { name: 'Musicista', keywords: ['musica', 'strumenti', 'concerti', 'band', 'cantante'] },
    en: { name: 'Musician', keywords: ['music', 'instruments', 'concerts', 'band', 'singer'] },
    es: { name: 'Músico', keywords: ['música', 'instrumentos', 'conciertos', 'banda', 'cantante'] }
  },
  {
    id: 'actor',
    icon: '🎭',
    it: { name: 'Attore/Attrice', keywords: ['teatro', 'recitazione', 'spettacolo', 'cinema', 'performance'] },
    en: { name: 'Actor/Actress', keywords: ['theater', 'acting', 'performance', 'cinema', 'show'] },
    es: { name: 'Actor/Actriz', keywords: ['teatro', 'actuación', 'espectáculo', 'cine', 'performance'] }
  },
  {
    id: 'writer',
    icon: '✍️',
    it: { name: 'Scrittore/trice', keywords: ['scrittura', 'libri', 'testi', 'copywriter', 'giornalista'] },
    en: { name: 'Writer', keywords: ['writing', 'books', 'texts', 'copywriter', 'journalist'] },
    es: { name: 'Escritor/a', keywords: ['escritura', 'libros', 'textos', 'copywriter', 'periodista'] }
  },
  {
    id: 'dancer',
    icon: '💃',
    it: { name: 'Ballerino/a', keywords: ['danza', 'ballo', 'coreografia', 'movimento', 'spettacolo'] },
    en: { name: 'Dancer', keywords: ['dance', 'choreography', 'movement', 'performance', 'show'] },
    es: { name: 'Bailarín/a', keywords: ['danza', 'baile', 'coreografía', 'movimiento', 'espectáculo'] }
  },

  // MODA E ABBIGLIAMENTO  
  {
    id: 'fashion_designer',
    icon: '👗',
    it: { name: 'Fashion Designer', keywords: ['moda', 'abiti', 'stile', 'stilista', 'collezioni'] },
    en: { name: 'Fashion Designer', keywords: ['fashion', 'clothes', 'style', 'designer', 'collections'] },
    es: { name: 'Diseñador de moda', keywords: ['moda', 'ropa', 'estilo', 'diseñador', 'colecciones'] }
  },
  {
    id: 'tailor',
    icon: '🧵',
    it: { name: 'Sarto/a', keywords: ['sartoria', 'abiti su misura', 'riparazioni', 'alterazioni'] },
    en: { name: 'Tailor', keywords: ['tailoring', 'custom clothes', 'repairs', 'alterations'] },
    es: { name: 'Sastre', keywords: ['sastrería', 'ropa a medida', 'reparaciones', 'alteraciones'] }
  },
  {
    id: 'personal_shopper',
    icon: '🛍️',
    it: { name: 'Personal Shopper', keywords: ['shopping', 'stile', 'consulenza', 'moda', 'acquisti'] },
    en: { name: 'Personal Shopper', keywords: ['shopping', 'style', 'consulting', 'fashion', 'purchases'] },
    es: { name: 'Personal Shopper', keywords: ['compras', 'estilo', 'consultoría', 'moda', 'adquisiciones'] }
  },
  {
    id: 'stylist',
    icon: '👔',
    it: { name: 'Stylist', keywords: ['stile', 'immagine', 'look', 'consulenza immagine', 'outfit'] },
    en: { name: 'Stylist', keywords: ['style', 'image', 'look', 'image consulting', 'outfit'] },
    es: { name: 'Estilista', keywords: ['estilo', 'imagen', 'look', 'consultoría de imagen', 'outfit'] }
  },

  // ANIMALI
  {
    id: 'veterinarian',
    icon: '🐾',
    it: { name: 'Veterinario/a', keywords: ['veterinario', 'animali', 'pets', 'cani', 'gatti'] },
    en: { name: 'Veterinarian', keywords: ['vet', 'animals', 'pets', 'dogs', 'cats'] },
    es: { name: 'Veterinario/a', keywords: ['veterinario', 'animales', 'mascotas', 'perros', 'gatos'] }
  },
  {
    id: 'pet_groomer',
    icon: '🐕',
    it: { name: 'Toelettatore', keywords: ['toelettatura', 'cani', 'animali', 'grooming', 'pulizia'] },
    en: { name: 'Pet Groomer', keywords: ['grooming', 'dogs', 'pets', 'cleaning', 'styling'] },
    es: { name: 'Peluquero canino', keywords: ['peluquería', 'perros', 'mascotas', 'limpieza', 'estilismo'] }
  },
  {
    id: 'dog_trainer',
    icon: '🦴',
    it: { name: 'Educatore cinofilo', keywords: ['addestramento', 'cani', 'comportamento', 'educazione'] },
    en: { name: 'Dog Trainer', keywords: ['training', 'dogs', 'behavior', 'education'] },
    es: { name: 'Adiestrador canino', keywords: ['adiestramiento', 'perros', 'comportamiento', 'educación'] }
  },
  {
    id: 'pet_sitter',
    icon: '🐈',
    it: { name: 'Pet Sitter', keywords: ['pet sitting', 'animali', 'cura', 'dog sitter', 'cat sitter'] },
    en: { name: 'Pet Sitter', keywords: ['pet sitting', 'animals', 'care', 'dog walker', 'cat care'] },
    es: { name: 'Cuidador de mascotas', keywords: ['cuidado mascotas', 'animales', 'paseo perros', 'cuidado gatos'] }
  },

  // SPORT E FITNESS
  {
    id: 'yoga_instructor',
    icon: '🧘‍♀️',
    it: { name: 'Insegnante Yoga', keywords: ['yoga', 'meditazione', 'benessere', 'mindfulness', 'respirazione'] },
    en: { name: 'Yoga Instructor', keywords: ['yoga', 'meditation', 'wellness', 'mindfulness', 'breathing'] },
    es: { name: 'Instructor de Yoga', keywords: ['yoga', 'meditación', 'bienestar', 'mindfulness', 'respiración'] }
  },
  {
    id: 'pilates_instructor',
    icon: '🤸',
    it: { name: 'Istruttore Pilates', keywords: ['pilates', 'fitness', 'postura', 'core', 'allenamento'] },
    en: { name: 'Pilates Instructor', keywords: ['pilates', 'fitness', 'posture', 'core', 'training'] },
    es: { name: 'Instructor de Pilates', keywords: ['pilates', 'fitness', 'postura', 'core', 'entrenamiento'] }
  },
  {
    id: 'sports_coach',
    icon: '⚽',
    it: { name: 'Allenatore sportivo', keywords: ['sport', 'allenamento', 'coach', 'atletica', 'squadra'] },
    en: { name: 'Sports Coach', keywords: ['sports', 'training', 'coach', 'athletics', 'team'] },
    es: { name: 'Entrenador deportivo', keywords: ['deporte', 'entrenamiento', 'coach', 'atletismo', 'equipo'] }
  },

  // TRASPORTI
  {
    id: 'driver',
    icon: '🚗',
    it: { name: 'Autista', keywords: ['trasporti', 'taxi', 'ncc', 'uber', 'chauffeur'] },
    en: { name: 'Driver', keywords: ['transport', 'taxi', 'chauffeur', 'uber', 'car service'] },
    es: { name: 'Conductor', keywords: ['transporte', 'taxi', 'chófer', 'uber', 'servicio auto'] }
  },
  {
    id: 'delivery',
    icon: '📦',
    it: { name: 'Corriere/Delivery', keywords: ['consegne', 'spedizioni', 'corriere', 'delivery', 'trasporti'] },
    en: { name: 'Delivery Service', keywords: ['delivery', 'shipping', 'courier', 'transport', 'logistics'] },
    es: { name: 'Servicio de entrega', keywords: ['entregas', 'envíos', 'mensajería', 'transporte', 'logística'] }
  },

  // CONSULENZA E BUSINESS
  {
    id: 'consultant',
    icon: '💼',
    it: { name: 'Consulente', keywords: ['consulenza', 'business', 'strategia', 'management', 'advisor'] },
    en: { name: 'Consultant', keywords: ['consulting', 'business', 'strategy', 'management', 'advisor'] },
    es: { name: 'Consultor', keywords: ['consultoría', 'negocios', 'estrategia', 'gestión', 'asesor'] }
  },
  {
    id: 'insurance_agent',
    icon: '🛡️',
    it: { name: 'Agente assicurativo', keywords: ['assicurazioni', 'polizze', 'rischio', 'protezione'] },
    en: { name: 'Insurance Agent', keywords: ['insurance', 'policies', 'risk', 'protection'] },
    es: { name: 'Agente de seguros', keywords: ['seguros', 'pólizas', 'riesgo', 'protección'] }
  },
  {
    id: 'recruiter',
    icon: '🤝',
    it: { name: 'Recruiter/HR', keywords: ['risorse umane', 'selezione', 'lavoro', 'recruiting', 'personale'] },
    en: { name: 'Recruiter/HR', keywords: ['human resources', 'recruitment', 'jobs', 'hiring', 'personnel'] },
    es: { name: 'Reclutador/RRHH', keywords: ['recursos humanos', 'selección', 'trabajo', 'contratación', 'personal'] }
  },

  // SERVIZI SPECIALIZZATI
  {
    id: 'interpreter',
    icon: '🌐',
    it: { name: 'Interprete/Traduttore', keywords: ['interpretariato', 'traduzioni', 'lingue', 'simultanea'] },
    en: { name: 'Interpreter/Translator', keywords: ['interpretation', 'translation', 'languages', 'simultaneous'] },
    es: { name: 'Intérprete/Traductor', keywords: ['interpretación', 'traducción', 'idiomas', 'simultánea'] }
  },
  {
    id: 'florist',
    icon: '🌸',
    it: { name: 'Fiorista', keywords: ['fiori', 'piante', 'composizioni', 'bouquet', 'decorazioni'] },
    en: { name: 'Florist', keywords: ['flowers', 'plants', 'arrangements', 'bouquets', 'decorations'] },
    es: { name: 'Florista', keywords: ['flores', 'plantas', 'arreglos', 'ramos', 'decoraciones'] }
  },
  {
    id: 'jeweler',
    icon: '💎',
    it: { name: 'Gioielliere', keywords: ['gioielli', 'oreficeria', 'oro', 'argento', 'pietre preziose'] },
    en: { name: 'Jeweler', keywords: ['jewelry', 'goldsmith', 'gold', 'silver', 'precious stones'] },
    es: { name: 'Joyero', keywords: ['joyería', 'orfebrería', 'oro', 'plata', 'piedras preciosas'] }
  },
  {
    id: 'optician',
    icon: '👓',
    it: { name: 'Ottico', keywords: ['occhiali', 'vista', 'lenti', 'optometria', 'montature'] },
    en: { name: 'Optician', keywords: ['glasses', 'vision', 'lenses', 'optometry', 'frames'] },
    es: { name: 'Óptico', keywords: ['gafas', 'visión', 'lentes', 'optometría', 'monturas'] }
  },

  // ASSOCIAZIONI E ORGANIZZAZIONI
  {
    id: 'association',
    icon: '🏛️',
    it: { name: 'Associazione', keywords: ['associazione', 'organizzazione', 'onlus', 'no profit', 'volontariato'] },
    en: { name: 'Association', keywords: ['association', 'organization', 'nonprofit', 'NGO', 'volunteer'] },
    es: { name: 'Asociación', keywords: ['asociación', 'organización', 'sin ánimo de lucro', 'ONG', 'voluntariado'] }
  },
  {
    id: 'community_center',
    icon: '🏘️',
    it: { name: 'Centro comunitario', keywords: ['comunità', 'centro sociale', 'aggregazione', 'attività'] },
    en: { name: 'Community Center', keywords: ['community', 'social center', 'activities', 'gathering'] },
    es: { name: 'Centro comunitario', keywords: ['comunidad', 'centro social', 'actividades', 'encuentro'] }
  },
  
  // ALTRO
  {
    id: 'other',
    icon: '📌',
    it: { name: 'Altro', keywords: ['altro', 'varie', 'diverso', 'non specificato'] },
    en: { name: 'Other', keywords: ['other', 'misc', 'different', 'unspecified'] },
    es: { name: 'Otro', keywords: ['otro', 'varios', 'diferente', 'no especificado'] }
  }
];

// Funzioni helper
export const getCategoryById = (id: string) => {
  return PROFESSIONAL_CATEGORIES.find(cat => cat.id === id);
};

export const getCategoriesByIds = (ids: string[]) => {
  return ids
    .map(id => getCategoryById(id))
    .filter((cat): cat is NonNullable<typeof cat> => cat !== null && cat !== undefined);
};

export const searchCategories = (query: string, language: 'it' | 'en' | 'es' = 'it', excludeIds: string[] = []) => {
  const normalizedQuery = query.toLowerCase().trim();
  
  let results = PROFESSIONAL_CATEGORIES;
  
  // Escludi categorie già selezionate
  if (excludeIds.length > 0) {
    results = results.filter(cat => !excludeIds.includes(cat.id));
  }
  
  if (!normalizedQuery) return results;
  
  return results.filter(category => {
    const categoryData = category[language];
    const nameMatch = categoryData.name.toLowerCase().includes(normalizedQuery);
    const keywordsMatch = categoryData.keywords.some(keyword => 
      keyword.toLowerCase().includes(normalizedQuery)
    );
    return nameMatch || keywordsMatch;
  });
};

export const getCategoriesForLanguage = (language: 'it' | 'en' | 'es' = 'it', excludeIds: string[] = []) => {
  return PROFESSIONAL_CATEGORIES
    .filter(cat => !excludeIds.includes(cat.id))
    .map(cat => ({
      id: cat.id,
      icon: cat.icon,
      name: cat[language].name,
      keywords: cat[language].keywords
    }));
};
